import { SectionMonitoringDashboard } from "components/monitoring/SectionMonitoringDashboard";

export default function Page() {
  return <SectionMonitoringDashboard />;
}
